import React from "react";

export type OptionProps = {
    key: any,
    value: any,
    children: any,
    _onClick?: () => void,
    className?: string,
    searchData?: string,
}

export const UiOption: React.FC<OptionProps> = (props) => {
    return (
        <div
            key={props.key}
            data-value={props.value}
            onClick={props._onClick}
            className={"w-full px-2 py-0.5 hover:bg-deep-blue-hover cursor-pointer" + (props.className ? " " + props.className : "")}
        >
            {props.children}
        </div>
    )
}
